import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '@/utils/constants';
import { useAuthStore } from '@/store/useAuthStore';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { firebaseUser } = useAuthStore();
  
  const isLoggedIn = !!firebaseUser;

  const navLinks = [
    { path: ROUTES.HOME, label: 'Home' },
    { path: ROUTES.PRICING, label: 'Pricing' },
    { path: ROUTES.DOCS, label: 'Documentation' },
  ];

  return (
    <header className="theme-main-menu menu-style-one">
      <div className="inner-content bg-wrapper bg-one border-20">
        <div className="top-header position-relative">
          <div className="d-flex align-items-center justify-content-between">
            <div className="logo order-lg-0">
              <Link to={ROUTES.HOME} className="d-flex align-items-center text-decoration-none">
                <div style={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  backgroundColor: '#000000',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '12px',
                  marginRight: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                  <img 
                    src="/images/logo/amebogpt-logo.png" 
                    alt="ameboGPT" 
                    style={{ 
                      maxWidth: '100%',
                      maxHeight: '100%',
                      width: 'auto',
                      height: 'auto',
                      objectFit: 'contain'
                    }} 
                  />
                </div>
                <span 
                  className="fw-bold text-dark"
                  style={{
                    fontSize: '32px',
                    fontFamily: '"Montserrat", sans-serif',
                    letterSpacing: '-0.5px',
                    lineHeight: '1.2em'
                  }}
                >
                  ameboGPT
                </span>
              </Link>
            </div>
            
            <div className="right-widget ms-auto ms-lg-0 me-3 me-lg-0 order-lg-3">
              <ul className="d-flex align-items-center style-none">
                {isLoggedIn ? (
                  <>
                    <li className="d-none d-md-inline-block ms-3">
                      <Link to={ROUTES.DASHBOARD} className="btn-two d-flex align-items-center gap-2">
                        {firebaseUser?.photoURL ? (
                          <img 
                            src={firebaseUser.photoURL} 
                            alt="" 
                            style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                          />
                        ) : (
                          <i className="bi bi-person-circle"></i>
                        )}
                        Dashboard
                      </Link>
                    </li>
                  </>
                ) : (
                  <li className="d-none d-md-inline-block ms-3">
                    <Link to={ROUTES.SIGNUP} className="btn-one">
                      Get Started
                    </Link>
                  </li>
                )}
              </ul>
            </div>
            
            <nav className="navbar navbar-expand-lg p0 order-lg-2">
              <button
                className="navbar-toggler d-block d-lg-none"
                type="button"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle navigation"
              >
                <span></span>
              </button>
              <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
                <ul className="navbar-nav align-items-lg-center">
                  <li className="d-block d-lg-none">
                    <div className="logo">
                      <Link to={ROUTES.HOME} className="d-flex align-items-center text-decoration-none">
                        <div style={{
                          width: '60px',
                          height: '60px',
                          borderRadius: '50%',
                          backgroundColor: '#000000',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '10px',
                          marginRight: '10px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                        }}>
                          <img 
                            src="/images/logo/amebogpt-logo.png" 
                            alt="ameboGPT" 
                            style={{ 
                              maxWidth: '100%',
                              maxHeight: '100%',
                              width: 'auto',
                              height: 'auto',
                              objectFit: 'contain'
                            }} 
                          />
                        </div>
                        <span 
                          className="fw-bold text-dark"
                          style={{
                            fontSize: '28px',
                            fontFamily: '"Montserrat", sans-serif',
                            letterSpacing: '-0.5px',
                            lineHeight: '1.2em'
                          }}
                        >
                          ameboGPT
                        </span>
                      </Link>
                    </div>
                  </li>
                  {navLinks.map((link) => (
                    <li key={link.path} className="nav-item">
                      <Link
                        to={link.path}
                        className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                  <li className="d-md-none ps-3 pe-3 mt-20">
                    {isLoggedIn ? (
                      <Link to={ROUTES.DASHBOARD} className="btn-two w-100 text-center">
                        Dashboard
                      </Link>
                    ) : (
                      <Link to={ROUTES.SIGNUP} className="btn-one w-100">
                        Get Started
                      </Link>
                    )}
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
